import '../shared/dynamic-tabs/dynamic-tabs.js';
import '../shared/blue-banner/blue-banner.js';;
import '../shared/cta/cta';

import { getText, appendText } from '../../assets/js/text-renderer';
import { setSharedCtaContent } from "../shared/shared-cta.js";


document.addEventListener('DOMContentLoaded', async () => {
  if (
    DEVELOPMENT || (
    window['__PRERENDER_INJECTED'] && 
    window['__PRERENDER_INJECTED'].render_text)
  ) await loadText();
});

const loadText = async () => {
  const data = await getText('services/data-preparation');
  const content = data.stories[0].content;

  setHeaderContent(content);
  setIntroContent(content);
  setSectionOneContent(content);
  setSectionTwoContent(content);
  setBlueBannerContent(content);

  await setSharedCtaContent();

  window.dispatchEvent(new CustomEvent('rendered-text', { detail: 'keywords' }));
  window.dispatchEvent(new CustomEvent('rendered-text', { detail: 'content' }));
};

function setHeaderContent(content) {
  appendText(content.header_pretitle, 'header-pretitle');
  appendText(content.header_title, 'header-title');
  appendText(content.summary, 'summary');
};

function setIntroContent(content) {
  appendText(content.intro_content, 'intro-content');
  appendText(content.intro_quote, 'intro-quote');
};

function setSectionOneContent(content) {
  appendText(content.section_1_title, 'section-1-title');
  appendText(content.section_1_content[0].title, 'estructura-tab');
  appendText(content.section_1_content[0].description, 'estructura-text')

  appendText(content.section_1_content[1].title, 'procesado-tab');
  appendText(content.section_1_content[1].description, 'procesado-text')

  appendText(content.section_1_content[2].title, 'seguridad-tab');
  appendText(content.section_1_content[2].description, 'seguridad-text')
};

function setSectionTwoContent(content) {
  appendText(content.section_2_title, 'section-2-title');
  appendText(content.section_2_content, 'section-2-content');
};

function setBlueBannerContent(content) {
  appendText(content.blue_banner, 'blue-banner');
};